const bbsFooter = {
  path: '/footernew',
  name: 'footerNew',
  component: () => import('@/views/footerNew/footerNew.vue')
}
export default bbsFooter
